export default __webpack_public_path__ + "static/media/ic_llp_40.430def49.svg";